export function SkipLink() {
  return (
    <a
      href="#main-content"
      className="skip-link fixed left-2 top-0 z-[100] -translate-y-full border border-fg bg-bg px-4 py-2 font-mono text-[11px] uppercase tracking-[0.12em] focus:translate-y-2"
    >
      Skip to main content
    </a>
  );
}